import React from "react";
import { Switch, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  toggle: {
    width: "100%",
    minWidth: "0",
  },
});

interface ToggleFieldProps {
  label: string;
  checked: boolean;
  onChange: (isChecked: boolean) => void;
}

export const ToggleField: React.FC<ToggleFieldProps> = ({
  label,
  checked,
  onChange,
}) => {
  const styles = useStyles();

  return (
    <Switch
      className={styles.toggle}
      label={label}
      checked={checked}
      onChange={(_ev, data) => onChange(data.checked)}
    />
  );
};

export default React.memo(ToggleField);
